import { useProjectContext } from '~/hooks';

export default function ExpectedITCPercentage() {
  const { projectState } = useProjectContext();

  return (
    <div className="expected-itc-percentage">
      <h3>
        Expected solar tax credit: <em>{projectState.expectedItcPercentage}%</em>
      </h3>
    </div>
  );
}
